export default "__VITE_ASSET__Cj1bmlW6__"